<div *ngIf="inBrowser" class="top-banner" [ngStyle]="{ 'background-image': 'url(' + imageURL + ')'}">
    <div class="inner-box">
        <span style="font-size: xx-large;" class="top-banner-text">
            <i class="faa faa-cloud-download faa-lg" style="padding-right: .5em;text-shadow: 1px 1px 2px darkgrey;"></i><label>Download Manager</label>
        </span>

        <!-- Control buttons for large screen -->
        <div class="control-btns" *ngIf="screenWidth > screenSizeBreakPoint" style="float: right;">
            <button pButton type="button" 
                (click)="downloadSelected()" 
                [disabled]="selectedFileCount==0"
                [ngStyle]="{'margin-right':'1em','width':'max-content','height': '2.5em', 'background-color':'#307F38', 'color': 'white'}">
                <i class="faa faa-download faa-1x icon-white" style="color: #fff; margin-right: 10px;"></i>
                Download Selected<p-badge [value]="selectedFileCount"></p-badge>
            </button>

            <button (click)="removeDownloaded()" pButton type="submit"
                style="margin-right:1em;width:max-content; height: 2.5em; background-color:rgb(82, 82, 82);"
                [disabled]="!anyDownloaded()">
                <i class="faa faa-trash faa-1x icon-white" style="color: #fff; margin-right: 10px;"></i>
                Remove downloaded
                <p-badge [value]="totalDownloaded"></p-badge>
            </button>

            <button (click)="removeSelected()" pButton type="submit"
                style="width:max-content; height: 2.5em; background-color:rgb(82, 82, 82);"
                [disabled]="selectedFileCount==0">
                <i class="faa faa-trash faa-1x icon-white" style="color: #fff; margin-right: 10px;"></i>
                Remove selected
                <p-badge [value]="selectedFileCount"></p-badge>
            </button>
        </div>
    </div>
</div>

<div class="full-span" *ngIf="screenWidth <= screenSizeBreakPoint">
    <div class="control-btns">
        <button (click)="downloadSelected()" pButton type="submit"
            [ngStyle]="{'width':'max-content','height':'2.5em','background-color':'#307F38'}"
            [disabled]="selectedFileCount==0">
            <i class="faa faa-download faa-1x icon-white" style="color: #fff; margin-right: 10px;"></i>
            Download Selected
            <p-badge [value]="selectedFileCount"></p-badge>
        </button>

        <button (click)="removeDownloaded()" pButton type="submit"
            style="margin-left:1em;width:max-content; height:2.5em; background-color:rgb(82, 82, 82);"
            [disabled]="!anyDownloaded()">
            <i class="faa faa-trash faa-1x icon-white" style="color: #fff; margin-right: 10px;"></i>
            Remove downloaded
            <p-badge [value]="totalDownloaded"></p-badge>
        </button>

        <button (click)="removeSelected()" pButton type="submit"
            style="margin-left:1em;width:max-content; height:2.5em; background-color:rgb(82, 82, 82);"
            [disabled]="selectedFileCount==0">
            <i class="faa faa-trash faa-1x icon-white" style="color: #fff; margin-right: 10px;"></i>
            Remove selected
            <p-badge [value]="selectedFileCount"></p-badge>
        </button>
    </div>
</div>